<template>
  <div class="matrix_layoutMain container" :class="getClassNameContainer">
    <div class="row matrix_layoutPackingContainerMainRow">
      <div class="col-md-8 matrix_layoutPackingContainerMain">
        <appOptionsTable v-if="getIsMobile">
          <div class="matrix_optionsContainer">
            <appOptionsContainer hideContainer="true"></appOptionsContainer>
            <appPackingOptionsContainer
              hideContainer="true"
            ></appPackingOptionsContainer>
            <appPreviewButton></appPreviewButton>
          </div>
        </appOptionsTable>
        <appPackingPreview></appPackingPreview>
        <div class="matrix_layoutPackingActions">
          <appTable
            :tableName="$t('Do you have your artwork ready?')"
            :tableClass="'packing-action--upload'"
          >
            <appUploadContainer :alwaysShow="true"></appUploadContainer>
          </appTable>
        </div>
      </div>
      <div class="col-md-4 matrix_layoutPackingContainerQuantity">
        <appOptionsTable v-if="!getIsMobile">
          <div class="matrix_optionsContainer">
            <appOptionsContainer hideContainer="true"></appOptionsContainer>
            <appPackingOptionsContainer
              hideContainer="true"
            ></appPackingOptionsContainer>
            <appPreviewButton></appPreviewButton>
          </div>
        </appOptionsTable>
        <appOtherOptionsTable>
          <appOtherOptionsContainer></appOtherOptionsContainer>
        </appOtherOptionsTable>
        <appCustomerNotesTable v-if="getShowCustomerNotes">
          <appCustomerNotes></appCustomerNotes>
        </appCustomerNotesTable>
        <appQuantityTable>
          <appQuantityContainer></appQuantityContainer>
          <appInputQuantity></appInputQuantity>
        </appQuantityTable>
        <appTable
          :tableName="$t('Continue')"
          :tableClass="'packing-action--editor'"
        >
          <div class="packing-action--elem">
            <div class="packing-action--label">
              {{ $t("Die cut") }}
            </div>
            <appDownloadPDFButton></appDownloadPDFButton>
          </div>
          <div v-show="getPersonalizationFullPage" class="packing-action--elem">
            <div class="packing-action--label">
              {{ $t("Design online?") }}
            </div>
            <appPersonalizationButton></appPersonalizationButton>
          </div>
          <appAddToCartButton
            :isDisabled="!(getAddToCartFullPage || getPersonalizationStatus)"
          ></appAddToCartButton>
        </appTable>
        <div class="matrix_summaryInformation">
          <appFactsheet></appFactsheet>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useConfigStore } from "@/stores/modules/config";
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { mapState, mapActions } from "pinia";
import { useWebproductStore } from "../../stores/modules/webproduct";

export default {
  computed: {
    ...mapState(useConfigStore, [
      "getAddToCartFullPage",
      "getPersonalizationFullPage"
    ]),
    ...mapState(usePersonalizeStore, ["getPersonalizationStatus"]),
    ...mapState(useWebproductStore, ["getShowCustomerNotes", "getIsMobile"])
  }
};
</script>
